import { updateObject, } from './../../utils/utility';

const initialState = {
    quoteList: [],
    quoteDetails: {},
    totalElements: 0,
    pageNumber: 0,
    totalPages: 0,
    quoteId: "",
    fileUploadStatus: '',
    quoteSaved: false,
    quoteSummary: {},
    isQuoteAccepted: false,
    savedQuoteId: '',
    companyListQuotes: [],
    legalEntityList: [],
    regionList: [],
    countryList: [],
    customerNameList: [],
    statusList: [],
    ctResponsibleList: [],
    requestorTypeList: [],
    vendorList: [],
    quoteListCopy: [],
}

const setQuoteSummary = (state = initialState, action) => {
    return updateObject(state, {
        quoteSummary: action.data
    });
}

const setQuoteSaved = (state = initialState, action) => {
    return updateObject(state, {
        quoteSaved: true,
        savedQuoteId: action.data.quoteId
    });
}

const setQuotesData = (state = initialState, action) => {
    const {
        quoteViewList, totalElements, pageNumber, totalPages,
        companyList, legalEntityList, countryList, statusList,
        customerNameList, regionList, ctResponsibleList, requestorTypeList, vendorList
    } = action.payload;
    return updateObject(state, {
        quoteList: quoteViewList,
        quoteListCopy: [...quoteViewList],
        totalElements,
        pageNumber,
        totalPages,
        isQuoteAccepted: false,
        companyList,
        legalEntityList,
        countryList,
        statusList,
        customerNameList,
        regionList,
        ctResponsibleList,
        requestorTypeList,
        vendorList
    });
};
const setVendorCTInitialQuotesData = (state = initialState, action) => {
    const { quoteViewList, totalElements, pageNumber, totalPages, companyList, regionList, customerNameList, statusList } = action.payload;
    return updateObject(state, {
        quoteList: quoteViewList,
        totalElements,
        pageNumber,
        totalPages,
        isQuoteAccepted: false,
        companyList,
        regionList,
        customerNameList,
        statusList
    });
};


const setDCDashboardDealsData = (state = initialState, action) => {
    const { dealList } = action.payload;
    return updateObject(state, {
        dealList: dealList,
    });
};

const setQuoteDetailsData = (state = initialState, action) => {
    const { isQuoteAccepted = false } = action;
    return updateObject(state, {
        quoteDetails: action.payload,
        isQuoteAccepted
    });
};

const resetQuoteSummaryData = (state = initialState) => {
    return updateObject(state, initialState);
}

const updateQuoteField = (state = initialState, action) => {
    const { name, value } = action.data;
    if (state.hasOwnProperty(name)) {
        return updateObject(state, {
            [name]: value
        });
    }
    return state;
}

const setCTQuotes = (state = {}, action) => {
    return updateObject(state, { ctQuotesForDashboard: action.payload });
}

const setDCQuotes = (state = {}, action) => {
    return updateObject(state, { dcQuotesForDashboard: action.payload });
}

const updateCTInitialQuotedata = (state = initialState, action) => {
    const { value, columnName, rowIndex } = action;
    const { quoteList } = state;
    quoteList[rowIndex] = { ...quoteList[rowIndex], [columnName]: value };
    return updateObject(state, { quoteList });
}

const restoreQuoteState = (state = initialState, action) => {
    const { quoteState = initialState } = action;
    return updateObject(state, { ...quoteState });
}

const reducer = (state = initialState, action) => {
    if (action.type === "SET_QUOTE_SUMMARY") {
        return setQuoteSummary(state, action)
    }
    else if (action.type === "SET_QUOTE_SAVED") {
        return setQuoteSaved(state, action)
    }
    else if (action.type === "RESET_QUOTE_SUMMARY_DATA") {
        return resetQuoteSummaryData(state, action)
    }
    else if (action.type === "SET_QUOTES_LIST") {
        return setQuotesData(state, action);
    }
    else if (action.type === "SET_VENDOR_CT_INITIAL_QUOTES_LIST") {
        return setVendorCTInitialQuotesData(state, action);
    }
    else if (action.type === "SET_QUOTES_DETAILS") {
        return setQuoteDetailsData(state, action);
    }
    else if (action.type === "UPDATE_QUOTE_FIELD") {
        return updateQuoteField(state, action);
    }
    else if (action.type === "SET_QUOTES_FOR_CT_DASHBOARD") {
        return setCTQuotes(state, action);
    }
    else if (action.type === "SET_QUOTES_FOR_DC_DASHBOARD") {
        return setDCQuotes(state, action);
    }
    else if (action.type === "SET_DC_DASHBOARD_DEALS_LIST") {
        return setDCDashboardDealsData(state, action);
    }
    else if (action.type === "UPDATE_CT_INITIAL_QUOTE_DATA") {
        return updateCTInitialQuotedata(state, action);
    }
    else if (action.type === "RESTORE_QUOTE_STATE") {
        return restoreQuoteState(state, action);
    }
    return state;
}

export default reducer;
